import { useState } from "react";
import { TourOverlay } from "./TourOverlay";

// A dica pode ser minimizada para liberar o formulário e o teclado no celular.
export function TourPractice({ steps, onDone, interactive = true }) {
  const [index, setIndex] = useState(0);
  return <TourOverlay step={steps[index]} index={index} total={steps.length} interactive={interactive}
    onClose={onDone} onBack={index ? () => setIndex(i => i - 1) : undefined}
    onNext={() => index === steps.length - 1 ? onDone() : setIndex(i => i + 1)}
    nextLabel={index === steps.length - 1 ? "Continuar tutorial" : "Próximo →"} />;
}
